import moment from 'moment';

export const getAuthorizationStatusText = (
  authorizations: any[],
  watchedDays: number,
): string => {
  if (!authorizations || authorizations.length === 0) {
    return 'No Active Authorizations';
  }

  const now = moment();
  const cutoffDate = moment().add(watchedDays, 'days');

  let relevantAuths = [];

  if (watchedDays === 0) {
    relevantAuths = authorizations
      .map(auth => ({endDate: moment(auth?.endDate)}))
      .filter(auth => auth.endDate.isBefore(now, 'day'));
  } else {
    relevantAuths = authorizations
      .map(auth => ({endDate: moment(auth?.endDate)}))
      .filter(auth => auth.endDate.isBetween(now, cutoffDate, undefined, '[]'));
  }

  if (relevantAuths.length === 0) {
    return '';
  }

  const soonest = relevantAuths.reduce((earliest, current) =>
    current.endDate.isBefore(earliest.endDate) ? current : earliest,
  );

  return watchedDays === 0
    ? `${soonest.endDate.format('MM/DD/YYYY')}`
    : `${soonest.endDate.format('MM/DD/YYYY')}`;
};
